// extracted by mini-css-extract-plugin
module.exports = {"album":"AlbumInfo_album__3jBxL","content":"AlbumInfo_content__3X3Of"};